export default "__VITE_ASSET__52iNYac2__"